import { AppConfigModel } from "../abstract/app-config.model";

export class AddressFormat extends AppConfigModel {

    static override CLASS_NAME: string = 'AddressFormat';
}
